import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api/api";
import { UserContext } from "../context/UserContext";
import { AlertContext } from "../context/AlertContext";
import "../css/auth.css";

const Register = () => {

  const [terminosAceptados, setTerminosAceptados] = useState(false); // ✅ MOVER ACÁ

  const userContext = useContext(UserContext);
  const alertContext = useContext(AlertContext);
  const navigate = useNavigate();

  const [nombre, setNombre] = useState("");
  const [correo, setCorreo] = useState("");
  const [password, setPassword] = useState("");

  if (!userContext || !alertContext) {
    return <div>Cargando...</div>;
  }

  const { login } = userContext;
  const { showAlert } = alertContext;

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!terminosAceptados) {
      showAlert("Debes aceptar los términos", "error");
      return;
    }

    try {
      const res = await API.post("/auth/register", {
        nombre,
        correo,
        password,
        terminos_aceptados: terminosAceptados
      });

      login(res.data.user, res.data.token);
      showAlert("Cuenta creada correctamente ⚽🔥", "success");
      navigate("/");
    } catch (error: any) {
      showAlert(
        error?.response?.data?.message || "Error al registrar.",
        "error"
      );
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>Crear Cuenta</h2>

        <form onSubmit={handleRegister}>
          <input
            placeholder="Nombre"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
          />

          <input
            placeholder="Correo"
            value={correo}
            onChange={(e) => setCorreo(e.target.value)}
          />

          <input
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <div className="terms-check">
            <input
              id="terminos"
              type="checkbox"
              checked={terminosAceptados}
              onChange={(e) => setTerminosAceptados(e.target.checked)}
              required
            />

            <label htmlFor="terminos">
              Acepto los{" "}
              <span
                className="terms-link"
                onClick={() => navigate("/terminos")}
              >
                Términos y Condiciones
              </span>
            </label>
          </div>

          <button type="submit">Registrarse</button>
        </form>
      </div>
    </div>
  );
};

export default Register;